import { render } from "./OtherIncomeEditor.vue?vue&type=template&id=630d2ba8&ts=true"
import script from "./OtherIncomeEditor.vue?vue&type=script&lang=ts"
export * from "./OtherIncomeEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__